/* global jQuery */
require('../../../css/uflex.css')

const Utils = require('./hierarchyUtils')

var angular = require('angular')
angular.module('promemoria').component('auiHierarchyTree', {
  template: require('./hierarchytree.html'),
  bindings: {
    current: '@',
    mediaicon: '@',
    levelcollapse: '@',
    url: '@',
    loaded: '='
  },
  controller: function ($scope, $element, $attrs, $http, ENDPOINT_SEARCH, LINKS) {
    var ctrl = this
    var jelem = jQuery($element)

    ctrl.albero = []
    ctrl.emptyTree = false
    ctrl.changelevel = parseInt(this.levelcollapse, 10) || 0    
    ctrl.numFondi = false

    /**
     * Contenitore di tutte le chiamate al server da parte del componente
     */
    const callAPI = {

      /**
       * Chiamo il server per recuperare il nodo
       * @param {string | number} identificativo del nodo da caricare
       * @return {Promise} Il nodo con quell'id
       */
      getNode: function (nodeId) {        
        return nodeId ? $http.post(ENDPOINT_SEARCH, {
          'table': 'hierarchy',
          'query': {'id': nodeId, 'access': 1}
        }) : {}
      },

      /**
       * Recupero tutti i nodi di Mongo corrispondenti a tutti i padri.
       * @param {string} parents - Elenco degli identificativi dei padri nella forma "/root/nonno/padre"
       * @return {Promise} i nodi rappresentanti i padri
       */
      getParents: function (parents) {
        return $http.post(ENDPOINT_SEARCH, {
          'table': 'hierarchy',
          'query': {'id': {'$in': parents.split('/') }, 'access': 1}
        })
      },

      /**
       * Recupero tutti i nodi che non hanno un parent, cioÃ¨ tutti i root
       * @return {Promise} i nodi root dell'albero
       */
      getAllRoots: function () {
        return $http.post(ENDPOINT_SEARCH, {
          'table': 'hierarchy',
          'query': {'parent_path': "1"}
        })
      }
    }

    ctrl.$onInit = function () {
      ctrl.loaded = false      
      if (typeof ctrl.current !== 'undefined' && ctrl.current !== '') {
        // Ho definito il current, parto a stampare da quello        
        currentFun()
      } else {
        // Ho richiesto l'albero nella sua interezza. Incomincio a stampare le root
        rootsFun()
      }
    }

    ctrl.genera = function (valore) {
      // find the node related to the id
      var node = _.find(ctrl.albero, {id: valore})
      var root
      // we are generating from current id
      if (node.parent_id === null) {
        node.children = _.orderBy(node.children, 'name')        
        root = node
        var html = "<ul class='no-bullet'></ul>"
        if (node.children) {
          html = generaHTML(node, 0)
        }
        // we have the tree, let's paste it
        jelem.find('#wpca_hierachy_items').append(html)
      } else {
        var parents = []
        // we start form the anchestor root
        if(node.parent_path && node.parent_path.length > 1) {
          parents = _.tail(node.parent_path.split('/'))
          var search = _.head(parents)
          root = _.find(ctrl.albero, {id : search})
        } else {
          parents = node.parent_path.split('/')
          root = _.find(ctrl.albero, {id : node.id})
        }
        
        if (root === null) {         
          return
        }
        root = {'children' : [root] }
        var html = "<ul class='no-bullet'>"
        html += stampa(root, parents, 0) + '</ul>'
        jelem.find('#wpca_hierachy_items').html(html)        
        jelem.find(`#wpca-parent-container_${root.table}_${valore} .wpca-parent-title`).addClass('current-item')
      }
      Utils.clickHierarchyItem(jelem, apri)     
    }

    /**
     * Stampo la lista dei figli di un nodo
     *
     * @param {object} node - Il nodo di cui stampare i figli
     * @returns
     */
    function generaHTML (node, level) {
      let html = "<ul class='no-bullet'>"
      node.children = node.children.sort(Utils.ordina)
      node.children.forEach(function (val) {
        if (val.access === '0') { return }
        let nodeGenerated = createNode(val, false, level)
        if (nodeGenerated !== null) {
          html += "<li class='closed level-" + level + "'>" + nodeGenerated + '</div></li>'
        }
      })
      html += '</ul>'
      return html
    };
    function apri (element, level) {
      var node = _.find(ctrl.albero, {id: element})
      if (!_.isEmpty(node)) {
        if (!node.has_child) {
          let html = generaHTML(node, level)
          jelem.find('#load').remove()
          jelem.find(`#wpca-parent-container_${node.table}_${element}`).append(html)    
        }
      } else {
        loadNode(element).then(function () {
          var node = _.find(ctrl.albero, {id: element})
          if (node === null) { return }

          let html = generaHTML(node, level)

          jelem.find('#load').remove()
          jelem.find(`#wpca-parent-container_${node.table}_${element}`).append(html)
        })
      }
    }

    /**
     * Stampo l'albero a partire da un nodo selezionato.
     * Consiste infatti di stampare tutti i livelli fino ad arrivare al nodo corrente. Ãˆ una funzione ricorsiva
     * @param {any} element - Il nodo da stampare
     * @param {any} child - I figli
     * @returns {string} html dell'albero
     */
    function stampa (element, child, level) {
      if (!element.has_child) {
        const e = child.splice(0, 1)[0]
        let html = ''

        // Sort
        element.children = element.children.sort(Utils.ordina)
        jQuery.each(element.children, function (index, val) {
          if (val.id === e) {
            html += "<li class='open level-" + level + "'>" + createNode(val, true, index) + "<ul class='no-bullet'>" +
            stampa(_.find(ctrl.albero, {id: e}), child, level + 1) + '</ul></div></li>'
            apri(val.id, level + 1)
          } else {
            html += "<li class='closed level-" + level + "'>" + createNode(val, false, index) + '</div></li>'
          }
        })
        return html
      }
      return '<li>' + createNode(element, false, 0) + '</div></li>'
    }

    function createNode (elem, open, level = 0) {
      if (elem.access === 0) { return '<div>' }
      var icon = (elem.isChild) ? 'fa-file' : (open) ? 'fa-minus' : 'fa-plus'
      var baseUrl = ctrl.url + LINKS[elem.table]
      let conservatore  = elem.conservatore || ''
      let a = (open) ? 'unfold' : 'fold'
      let link = baseUrl + '?id=' + elem.id
      let item = "<div class='wpca-parent-container' id='wpca-parent-container_" + elem.table + '_' + elem.id + "'"
      item += "data-id='" + elem.id + "'"
      item += "data-level='" + level + "'"
      item += "data-table='" + elem.table + "' >"
      item += "<div class='p-top-half u-flex'>"          
      if(!elem.isChild) {
        item += "<div class='toggler " + a + "'><span class='fa " + icon + "' ></span></div>"
      } else {          
        item += "<div class='toggler'><span class='fa " + icon + "' ></span></div>"
      }
      item += "<div class='wpca-parent-title p-bottom-half bb-g1'><a href='" + link + "' class=\"u-flex u-flexCol\"><span class=\"blue bolder\">" + getname(elem) + "</span><span class=\"grey-light\">" + conservatore + "</span></a></div>"
      item += '</div>'
      return item
    }

    function getname (elem) {
      var name = ''
      
      if (typeof elem.num !== 'undefined' && elem.num !== '') {
        name += elem.num + '. ' + elem.name
      } else {
        name += elem.name
      }

      // name += elem.name

      // if (typeof elem.data !== 'undefined' && elem.data !== '') {
      //   name += ', <i>' + elem.data + '</i>'
      // }

      // if (typeof elem.type !== 'undefined' && elem.type !== '') {        
      //   name += ' (' + elem.type + ')'
      // }
    
      return name
    }

    function loadNode (elem) {
      return new Promise(function (resolve, reject) {
        callAPI
        .getNode(elem)
        .then(function (json) {
          if (json.data.data !== -1) {
            ctrl.albero.push(...json.data.data)
            ctrl.albero.sort(Utils.sortTreeNode)
            resolve()
          } else {
            reject()
          }
        })
      })
    }

    function currentFun () {
      callAPI
          .getNode(ctrl.current)
          .then(function (data) {
            if (data.data.count > 0) {
              var currentNode = data.data.data[0]
              ctrl.albero.push(currentNode)

              if (currentNode.parent_path !== null) {
              // Risalgo la gerarchia

                callAPI
                .getParents(currentNode.parent_path)
                .then(function (result) {
                    // Aggiungo i padri all'albero
                  if (data.data.count > 0) {
                    ctrl.albero.push(...result.data.data)

                    // Ordino per mantenere logaritmica la ricerca
                    ctrl.albero.sort(Utils.sortTreeNode)
                    ctrl.genera(ctrl.current)
                  }
                })
              } else {
                ctrl.genera(ctrl.current)
              }
            } else { // L'albero non ha elementi
              ctrl.emptyTree = true
            }
            ctrl.loaded = true // Ho finito di caricare tutto
          })
    }

    function rootsFun () {
      // Parto dalle root      
      callAPI
        .getAllRoots()
        .then(function (data) {
          if (data.data.count <= 0) {
            ctrl.emptyTree = true
          }

          if (data.data.count > 0) {
            jelem.find('#wpca_hierachy_items').addClass('superoot')
            ctrl.numFondi = data.data.count
          }

          for (let i = 0; i < data.data.count; i++) {
            data.data.data[i].parent_id = -1
            ctrl.albero.push(data.data.data[i])
          }


          ctrl.albero.push({
            access: '1',
            children: data.data.data,
            id: -1,
            has_child: false,
            name: '',
            parent_id: null,
            hasMedia: false
          })
          ctrl.albero.sort(Utils.sortTreeNode)
          ctrl.genera(-1)

          ctrl.loaded = true
        })
    }
  }
})


// WEBPACK FOOTER //
// ./src/js/components/hierarchytree/hierarchytree.js